import type { AttendanceStatusFilter, EmployeeStatusFilter } from "../types";

export const CHECK_IN_THRESHOLD = "09:36:00";

export const STATUS_OPTIONS: { value: AttendanceStatusFilter; label: string }[] = [
  { value: "All", label: "All" },
  { value: "Present", label: "Present" },
  { value: "Absent", label: "Absent" },
  { value: "Late", label: "Late" },
];

export const EMPLOYEE_STATUS_OPTIONS: { value: EmployeeStatusFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "suspended", label: "Suspended" },
];

export const DEFAULT_EMPLOYEE_STATUS: EmployeeStatusFilter = "active";

export const LEAVE_PART_LABELS: Record<string, string> = {
  "full|full": "Full Day",
  "full|first_half": "Till 1st Half",
  "full|second_half": "Till 2nd Half",
  "first_half|first_half": "1st Half",
  "first_half|full": "From 1st Half",
  "second_half|second_half": "2nd Half",
  "second_half|full": "From 2nd Half",
  "second_half|first_half": "2nd Half → 1st Half",
  "first_half|second_half": "1st Half → 2nd Half",
};
